<div class="pw-input" [formGroup]="parentFormGroup">
	<label class="pw-input__label" *ngIf="data.label">
    {{ data.label }}
  </label>

	<div class="pw-input__wrapper">
		<input class="pw-input__input" name="{{ data.name }}" type="{{ data.type }}" id="{{ data.name }}" autocomplete="off" formControlName="{{ data.name }}"/>
	</div>
  <label class="pw-input__error" [innerHTML]="formStatus.formErrors[data.name]" id="error_{{ data.name }}" *ngIf="formStatus.formErrors[data.name]" role="alert"></label>
</div>